//Annoy
const annoy_html = '<div class="modal fade" tabindex="-1" data-bs-backdrop="static" ><div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document"><div class="modal-content"> \
    <div class="modal-header"> \
        <div class="modal-title flex-grow-1" ></div> \
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> \
    </div> \
    <div class="modal-body"></div> \
    <div class="modal-footer"></div> \
</div></div></div>';

export function Annoy(options) {
    let defaults = {
            title: 'Information',
            body: '',
            size: '',
            reload_height: true,
            buttons: [
                {
                    text: "Ok",
                    callback: function () {
                    },
                    dismiss: true,
                    class: 'btn-primary'
                }, {
                    text: "Cancel",
                    callback: function () {
                    },
                    dismiss: true,
                    class: 'btn-light border'
                }
            ],
            vertically_centered: true,
            modal_id: 'modal-annoy-' + maggieland.generateGuid(),
            enable_close_button: true,
            backdrop: true,
            keyboard: true,
            overflow: true,
        },
        button_defaults = {
            text: "Ok",
            callback: function () {
            },
            dismiss: true,
            class: 'btn-primary'
        },
        settings = $.extend({}, defaults, options),
        el_modal = $(annoy_html);

    if (settings.title.length) {
        el_modal.find('.modal-title').html(settings.title);
    } else {
        el_modal.find('.modal-title').remove();
    }

    if (settings.overflow) {
        el_modal.find('.modal-dialog').addClass('modal-modal-dialog-scrollable');
    }

    el_modal.find('.modal-body').html(settings.body);

    if (settings.buttons.length > 0) {
        for (let i = 0; i < settings.buttons.length; i++) {
            let button_options = settings.buttons[i],
                button_settings = $.extend({}, button_defaults, button_options),
                button = $('<button type="button" class="btn"></button>');

            button.html(button_settings.text);
            button.addClass(button_settings.class);

            if (button_settings.dismiss) {
                button.attr('data-dismiss', 'modal');
            }

            button.on('click', function () {
                button_settings.callback();

                if (button_settings.dismiss) {
                    $("#" + settings.modal_id).modal('hide');

                    // if iframe exist inside modal
                    $("#" + settings.modal_id + ' iframe').removeAttr('src');
                }
            });

            el_modal.find('.modal-footer').append(button);
        }

    } else {
        el_modal.find('.modal-footer').remove();
    }

    if (settings.size) {
        el_modal.find(".modal-dialog").addClass(settings.size);
    }

    if (settings.vertically_centered) {
        el_modal.find(".modal-dialog").addClass("modal-dialog-centered");
    }

    if (settings.enable_close_button) {
        el_modal.find(".modal-header .btn-close").on('click', function () {
            $("#" + settings.modal_id).modal('hide');

            // if iframe exist inside modal
            $("#" + settings.modal_id + ' iframe').removeAttr('src');
        });

    } else {
        el_modal.find('button[data-bs-dismiss="modal"]').addClass('d-none');
    }

    el_modal.attr("id", settings.modal_id);
    el_modal.appendTo($('body'));

    /*el_modal.find('button[data-bs-dismiss="modal"]').on("click",function() {
        el_modal.hide();
    });*/

    // [ML] on hide, trigger
    el_modal.on('hidden.bs.modal', function (event) {
        // Destroy modal
        el_modal.remove();
    });

    let modal = new bootstrap.Modal($("#" + settings.modal_id), {});
    modal.show();

    if (settings.reload_height) {
        modal.handleUpdate();
    }
}

export function Alert(body, title = false, options = {}, ok_callback = false, modal_id = 'modal-alert') {
    let defaults = {
        body: body,
        title: title || 'Alert',
        modal_id: modal_id,
        buttons: [
            {
                text: "Ok",
                callback: ok_callback || function () {
                },
                dismiss: true,
                class: 'btn-primary'
            }
        ]
    };

    let final_options = $.extend({}, defaults, options);

    Annoy(final_options);
}

export function Confirm(body, title, btn_ok_callback = false, btn_cancel_callback = false, btn_ok_text = false, btn_cancel_text = false, modal_id = 'modal-confirm') {
    let options = {
        body: body,
        title: title || 'Confirm',
        modal_id: modal_id,
        buttons: [
            {
                text: btn_ok_text || "Yes",
                callback: btn_ok_callback || function () {
                },
                dismiss: true,
                class: 'btn-success'
            },
            {
                text: btn_cancel_text || "No",
                callback: btn_cancel_callback || function () {
                    $(".menu-hider").removeClass("menu-active");
                },
                dismiss: true,
                class: 'btn-secondary border'
            },
        ]
    };

    Annoy(options);
}
